import type { ReactNode } from 'react';

export function PageShell({
  title,
  subtitle,
  error,
  children,
}: {
  title?: string;
  subtitle?: string;
  error?: string | null;
  children: ReactNode;
}): JSX.Element {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      {title && <h1 className="text-2xl font-bold mb-1">{title}</h1>}
      {subtitle && <p className="text-gray-600 mb-4">{subtitle}</p>}
      {error && (
        <div className="rounded border border-red-300 bg-red-50 px-3 py-2 text-sm text-red-700 mb-4">
          {error}
        </div>
      )}
      {children}
    </div>
  );
}
